import { isValidURL } from 'utils';

import React, { useState } from 'react';

import { t } from 'i18next';

import { PREVIEW_TEXT_LENGHT } from 'constants/global';

import Tags from '../Tags';
import VectorIcon from './icons/Vector.svg';
import {
  Container,
  Content,
  ContentWrapper,
  LocationWrapper,
  StyledText,
  Title,
} from './styles';

interface MeetingContentProps {
  title: string;
  content: string;
  location: string;
  tags: string[];
}

const MeetingContent: React.FC<MeetingContentProps> = ({
  title,
  content,
  location,
  tags,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleContent = () => {
    setIsExpanded(!isExpanded);
  };

  const isContentLong = content.length > PREVIEW_TEXT_LENGHT;
  const contentPreview =
    isExpanded || !isContentLong
      ? content
      : content.substring(0, PREVIEW_TEXT_LENGHT) + '...';

  return (
    <Container>
      <ContentWrapper>
        <Title>{title}</Title>
        <Content>{contentPreview}</Content>
        {isContentLong && (
          <StyledText onClick={toggleContent}>
            {isExpanded ? 'See less' : 'See more'}
          </StyledText>
        )}
        <LocationWrapper>
          <img src={VectorIcon} alt={t('vector')} />
          {isValidURL(location) ? (
            <a href={location} target="_blank" rel="noopener noreferrer">
              {location}
            </a>
          ) : (
            location
          )}
        </LocationWrapper>
        <Tags tags={tags} />
      </ContentWrapper>
    </Container>
  );
};

export default MeetingContent;
